module.exports = __webpack_public_path__ + "img/key-icon.7677ea6c.svg";